import {ReactNode} from "react";
import {Moment} from "moment/moment";

export class UtilsService {

    static rangeCheck(val: number, max: number, min: number): number {
        if (val < min) {
            val = min;
        } else if (val > max) {
            val = max;
        }
        return val;
    }

    /**
     * Renders a ReactNode based on a truthy condition. Else can be optionally provided either as a ReactNode or a function returning a ReactNode.
     * If you are using `elseContent` it is recommended that you wrap you're ReactNodes in functions to avoid them getting executed even when conditions are not met.
     * For example, if `elseContent` is provided, and you have functions within it that will error without some specific data, you should wrap the ReactNode in a function,
     * so it only gets called when the condition becomes falsy. Otherwise you'll get errors even though the condition is still true, as both ReactNodes will get executed,
     * even though they are not both rendered.
     * @param condition
     * @param content
     * @param elseContent
     */
    static renderIf(condition: any, content: ReactNode | (() => ReactNode), elseContent: ReactNode | (() => ReactNode) = null): ReactNode {
        return condition ? (
            typeof content === 'function' ? content() : content
        ) : (
            typeof elseContent === 'function' ? elseContent() : elseContent
        );
    }

    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    static hexToRgb(hex: string): number[] {
        return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
            ,(m, r, g, b) => '#' + r + r + g + g + b + b)
            .substring(1).match(/.{2}/g)
            .map(x => parseInt(x, 16))
    }

    /**
     * Runs through each of `propNames` on object and assigns an empty object if `undefined`.
     * @param obj - any object
     * @param propNames - array of property names in order
     */
    static fillWithEmpty(obj: any, propNames: string[]): void {
        const prop = propNames[0];
        if (prop && obj[prop] === undefined) {
            obj[prop] = {};
        }
        propNames.shift();
        if (propNames.length) {
            this.fillWithEmpty(obj[prop], propNames);
        }
    }

    static getViewDateFromMoment(moment: Moment): string {
        return moment.format('dddd, MMMM D, YYYY');
    }
}

export const renderIf = UtilsService.renderIf;